<div class="modal-dialog tsa-log-dialog">
  <div class="modal-content">
    <div class="modal-header">TS Analyzer Log &mdash; {{ data.filename }}</div>

    <div class="modal-body">
      <pre class="tsa-log-body">{{ data.content }}</pre>
    </div>

    <div class="modal-footer">
      <span class="modal-footer-left">
        <button type="button" class="btn cl-color-secondary" (click)="copy()">
          <span>{{ copied() ? 'Copied' : 'Copy' }}</span>
        </button>
      </span>
      <span class="modal-footer-center"></span>
      <span class="modal-footer-right">
        <button type="button" class="btn cl-color-secondary" (click)="dialogRef.close()">
          <span>Close</span>
        </button>
      </span>
    </div>
  </div>
</div>
